import React from 'react';
import {MasterLayout} from 'layout';
import { KetQuaTheoDoiThucHien } from 'modules/theo-doi-thuc-hien';

class KetQuaXuLyTheoDoiThucHienPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <KetQuaTheoDoiThucHien params={this.props.params}/>
      </MasterLayout>
    );
  }
}

export default KetQuaXuLyTheoDoiThucHienPage;


// WEBPACK FOOTER //
// ./src/components/pages/theo-doi-thuc-hien/KetQuaXuLyTheoDoiThucHienPage.jsx